// Ein Einwand-Block ist selten EIN Text. Die Blöcke der Bibliothek tragen die zwei Stufen der
// Einwandbehandlung als Marken im Fliesstext:
//
//     @@ ARA @@
//     Das klingt doch super, blockt ihr die Bots nur oder …
//
//     @@ ACE @@
//     Verstehe ich, kurze Frage, wenn du sagst, dass ihr euch schon kümmert …
//
// Bis 2026-08-21 hat die Anrufansicht das nicht gewusst: sie hat den ganzen Block am Stück
// hingelegt, Marken inklusive. Wer am Telefon „Wir machen das bereits" hörte, las also erst
// „@@ ARA @@" vor — und hatte ARA und ACE gleichzeitig vor sich, obwohl ACE erst dran ist, wenn
// ARA nicht getragen hat.
//
// Was die Marken heissen, entscheidet das Skript, nicht dieser Code. ARA und ACE sind der
// Bestand, aber ein Block mit „@@ Einstieg @@ / @@ Vertiefung @@" zerfällt genauso — hier steht
// nur, WO getrennt wird, nie WAS die Stufen bedeuten.
//
// Toleranzen, alle aus echten Blöcken:
//   - beliebig viele @ (`@@ ARA @@` und `@@@@ ARA @@@@` kommen beide vor),
//   - Leerzeichen um Marke und @,
//   - Text VOR der ersten Marke (dann ist das die erste, unbenannte Stufe),
//   - gar keine Marke (dann ist der ganze Block eine Stufe — der Normalfall bei Ablauf-Blöcken).
const MARKE = /^[ \t]*@{2,}[ \t]*([^@\n]*?)[ \t]*@{2,}[ \t]*$/;

export type SkriptTeil = { marke: string | null; text: string };

/** Zerlegt einen Block-Text in seine Stufen. Liefert IMMER mindestens eine. */
export function skriptTeile(body: string): SkriptTeil[] {
  const zeilen = (body || '').split('\n');
  const teile: SkriptTeil[] = [];
  let marke: string | null = null;
  let puffer: string[] = [];

  const ablegen = () => {
    const text = puffer.join('\n').trim();
    // Eine Marke ohne Text ist trotzdem eine Stufe (der Block ist dann eben noch leer) — ein
    // Vorspann ohne Text dagegen ist nur die Leerzeile vor der ersten Marke und fällt weg.
    if (marke !== null || text) teile.push({ marke, text });
    puffer = [];
  };

  for (const zeile of zeilen) {
    const treffer = zeile.match(MARKE);
    if (treffer) {
      ablegen();
      marke = treffer[1].trim() || null;
    } else {
      puffer.push(zeile);
    }
  }
  ablegen();

  return teile.length ? teile : [{ marke: null, text: (body || '').trim() }];
}
